<template>
    <div class="search-condition-date-range">
        <input
                type="text"
                id="create-timeonly-from"
                name="create-timeonly-from"
                :value="value"
                @input="keyup"
                v-on:change="startDateChange"
                placeholder="请选择时间"
                data-date-format="yyyy/mm/dd"
                onfocus="(this.type='time')"
                onblur="(this.type='text')"
        />
    </div>
</template>

<script>
    export default {
        name: "BInputTimeRange",
        props: {
            value: String,
        },
        methods: {
            startDateChange(event) {
                this.$emit("startTimeChange", event.target.value);
            },
            keyup(e) {
                this.$emit("input", e.target.value);
            }
        },
    };
</script>

<style scoped>
    .search-condition-date-range {
        display: flex;
        align-items: center;
    }

    .search-condition-date-range label:nth-of-type(1) {
        color: #333333;
        width: 70px;
        text-align: right;
        margin: 0 10px 0 20px;
    }

    .search-condition-date-range label:nth-of-type(2) {
        color: #333333;
        text-align: right;
        margin: 0 10px 0 10px;
    }

    .search-condition-date-range input {
        width: 220px;
        height: 42px;
        background: #ffffff;
        border: 1px solid #dee2e6;
        border-radius: 5px;
        font-weight: 400;
        color: #666666;
        padding-left: 10px;
        padding-right: 10px;
        margin: 12px 0 12px 0;
    }

    input:focus {
        border: 1px solid #0171A3;;
    }

    * {
        outline: none;
    }
</style>